<template>
  <div>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">Ticket {{ item ? `${item.id}` : "" }}</h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :parentpage="parentPage" :page="currentPage" />
        </div>
      </div>
    </div>
    <loading-container :loading="loading">
      <div v-if="!item" class="text-center">No Ticket found</div>
      <div v-else class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              Ticket Summary
              <div class="card-actions">
                <form-button
                  type="info"
                  class="ml-1"
                  :loading="update_loading"
                  text="Proccessing"
                  v-if="item.status === 'created' && currentRole !== 'seller'"
                  :click="() => updateStatus('processing')"
                />
                <form-button
                  type="danger"
                  class="ml-1"
                  :loading="update_loading"
                  text="Close"
                  :click="() => updateStatus('closed')"
                  v-if="item.status !== 'closed'"
                />
                <form-button
                  type="warning"
                  class="ml-1"
                  :loading="update_loading"
                  text="Reopen"
                  :click="() => updateStatus('created')"
                  v-if="item.status === 'closed'"
                />
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <tbody>
                    <tr>
                      <td>Status</td>
                      <td>
                        <ticket-status :status="item.status"></ticket-status>
                      </td>
                    </tr>
                    <tr>
                      <td>Title</td>
                      <td>{{ item.title }}</td>
                    </tr>
                    <tr>
                      <td>Topic</td>
                      <td>
                        <topic-label :label="item.topic"></topic-label>
                      </td>
                    </tr>
                    <tr v-if="item.orderId">
                      <td>Order Id</td>
                      <td>{{ item.orderId }}</td>
                    </tr>
                    <tr>
                      <td>Message</td>
                      <td>
                        <b>{{ item.message }}</b>
                      </td>
                    </tr>
                    <tr>
                      <td>Created At</td>
                      <td>{{ item.createdAt | datetimeDisplay }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" v-if="item.attachments && item.attachments.length > 0">
          <div class="card">
            <div class="card-header">Attachments</div>
            <div class="card-body">
              <div class="row el-element-overlay">
                <div
                  v-for="(image, index) in item.attachments"
                  :key="index"
                  class="col-lg-1 col-md-2 col-3"
                >
                  <div class="card m-0 p-0 h-100">
                    <div class="el-card-item m-0 p-0 h-100">
                      <a
                        @click="openGallery(index)"
                        class="el-card-avatar m-0 p-0 h-100 cursor-pointer"
                      >
                        <img v-lazy="image" :src="image" alt="image" class="img-responsive radius" />
                        <div class="el-overlay"></div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="card">
             <div class="card-header">Message</div>
              <div class="card-body">
                  <div class="message-box">
                      <div class="message-widget message-scroll">
                          <!-- Message -->
                          <a 
                            v-for="(message,i) in messagesHistory"
                            :key="i+'chatbox'">
                              <div class="user-img">
                                  <img 
                                    :src="message.sender.profileImg ? message.sender.profileImg: 'https://ui-avatars.com/api/?name=Default'"
                                    alt="user" 
                                    class="img-circle">
                                  <span class="profile-status online pull-right"></span>
                              </div>
                              <div class="mail-contnet">
                                  <h5>{{message.sender.name}}</h5>
                                  <span class="mail-desc">
                                    {{message.message}}
                                  </span>
                                  <span class="time">{{message.createdAt | datetimeDisplay}}</span>
                                  <div
                                    class="d-flex justify-start align-stretch"
                                    v-if="message.attachments && JSON.parse(message.attachments).length>0"
                                  >
                                    <a
                                      @click="loadImageSlideShow(img)"
                                      v-for="(img,j) in JSON.parse(message.attachments)"
                                      :key="j+'chat-attach'"
                                      class="p-0 pr-1 cursor-pointer"
                                    >
                                      <img :src="img" alt class="user-img img-responsive radius m-1" />
                                    </a>
                                  </div>
                              </div>
                          </a>
                      </div>
                  </div>
              </div>
              <div class="card-body border-top">
                <form>
                  <div class="row">
                    <div class="col-12 d-flex">
                      <div class="attach-box">
                        <input
                          multiple
                          type="file"
                          accept="image/*"
                          ref="fileInput"
                          class="attach-control"
                          @change="processFile($event)"
                          @click="$refs.fileInput.value = null"
                        />
                      </div>
                      <div class="attach-list pl-2">
                        <div class="attach-item" v-for="(img,i) in attachFile" :key="i+'attach'">
                          <div class="label label-table label-default text-success">{{img.name}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-8 col-md-10 col-lg-10">
                      <text-area
                        :value="form.message"
                        name="message"
                        placeholder="Type your message here"
                        :required="true"
                        :errors="error.message"
                        :isMessage="true"
                        @input="value => setField({ key: 'message', value })"
                      />
                    </div>
                    <div class="col-4 col-md-2 col-lg-2 text-right">
                      <div class="btn-group" :class="{ 'show' : sendToggle }">
                        <form-button type="success" class="btn btn-success" 
                          inputType="button"
                          :click="() => sellerCreateMsg()"
                          :loading="formLoading">
                          Send
                        </form-button>
                        <span class="outside-click" v-if="sendToggle" @click="sendToggle = false"></span>
                        <button type="button" class="btn btn-success dropdown-toggle dropdown-toggle-split relative" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="sendToggle = !sendToggle">
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div class="dropdown-menu send-group-btn" :class="{ 'show' : sendToggle }">
                          <a class="dropdown-item cursor-pointer btn btn-success" @click="sendWithStatusAction('processing')" v-if="currentRole == 'supporter' || currentRole == 'admin'">Send & Process</a>
                          <a class="dropdown-item cursor-pointer btn btn-success" @click="sendWithStatusAction('closed')">Send & Close Ticket</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <modal
        :show="form.showImageSlideShow"
        :close="() => setField({ key: 'showImageSlideShow', value: false })"
        className="modal-dialog-centered"
      >
        <img :src="imageSlide" class="img-responsive">
      </modal>
      <LightBox
        v-if="media.length > 0"
        ref="lightbox"
        :media="media"
        :show-caption="false"
        :show-light-box="false"
      />
    </loading-container>
  </div>
</template>
<style>
@import "../../assets/css/pages/user-card.css";
@import "../../assets/css/pages/chat-app-page.css";
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";

import LoadingContainer from "@/components/Misc/LoadingContainer";
import Breadcrumb from "@/components/Common/Breadcrumb";
import Modal from "@/components/Misc/Modal";
import LinkButton from "@/components/Misc/LinkButton";
import TextArea from "@/components/Form/TextArea";
import FormButton from "@/components/Form/FormButton";
import TopicLabel from "@/components/Common/TopicLabel";
import TicketStatus from "@/components/Common/TicketStatus";
import LightBox from 'vue-image-lightbox';

export default {
  name: "TicketDetail",
  components: {
    LoadingContainer,
    Breadcrumb,
    Modal,
    LinkButton,
    TextArea,
    FormButton,
    TopicLabel,
    TicketStatus,
    LightBox
  },
  beforeMount() {
    const ticketId = this.$route.params.ticketId;
    this.getTicket(ticketId);
    this.markReadTicket(ticketId);
  },
  computed: {
    ...mapGetters({
      loading: "ticket/loading",
      update_loading: "ticket/update_loading",
      user: "auth/user",
      item: "ticket/item",
      form: "ticket/form",
      formLoading: "ticket/formLoading",
      sendMsgModal: "ticket/sendMsgModal",
      error: "ticket/error",
      imageSlide: "ticket/imageSlide"
    }),
    routeName() {
      return this.$router.name;
    },
    currentPage() {
      return this.$store.state.route.meta.title;
    },
    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
    parentPage() {
      let page = {
        title: "Ticket",
        name: "ticketList"
      };

      return page;
    },
    messagesHistory() {
      return _.sortBy(this.item.messages, o => o.createdAt);
    },
    attachFile() {
      return this.form.attachments;
    },
    media() {
      if (this.item && this.item.attachments) {
        return this.item.attachments.map(item => {
          return {
            thumb: item,
            src: item
          }
        });
      }
      return [];
    }
  },
  data() {
    return {
      sendToggle: false
    }
  },
  methods: {
    ...mapActions({
      setField: "ticket/setField",
      getTicket: "ticket/getTicket",
      addImages: "ticket/addImages",
      openModal: "ticket/openModal",
      closeModal: "ticket/closeModal",
      updateTicket: "ticket/updateTicket",
      sellerCreateMsg: "ticket/sellerCreateMsg",
      sendWithStatus: "ticket/sendWithStatus",
      loadImageSlideShow: "ticket/loadImageSlideShow",
      markReadTicket: "ticket/markReadTicket"
    }),
    processFile(event) {
      const uploadFiles = event.target.files;
      this.addImages({ files: [...uploadFiles] });
    },
    updateStatus(status) {
      this.setField({ key: "status", value: status });
      this.updateTicket();
    },
    sendWithStatusAction(status) {
      this.sendWithStatus(status);
      this.sendToggle = false;
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    }
  }
};
</script>

<style scoped>
.el-element-overlay .el-card-item .el-overlay-1 img {
  border: 1px solid #ddd;
  height: 100%;
}
.chat-main-box {
  overflow: unset !important;
}
.chat-main-box .chat-right-aside {
  width: 100%;
}

.chat-list li .chat-content {
  padding-left: 0;
}

.chat-main-box .chat-right-aside .chat-list {
  max-height: 300px;
  overflow: auto;
}

.chat-list li .chat-content .box img {
  max-height: 150px;
}
.chat-list li .chat-time-reverse {
  display: block;
  font-size: 10px;
  color: #6c757d;
  margin: 5px 0 15px 65px;
  margin-top: 5px;
  margin-right: 0px;
  margin-bottom: 15px;
  margin-left: 65px;
}
.chat-list li .chat-time {
  display: block;
  font-size: 10px;
  color: #6c757d;
  margin: 5px 65px 15px 0;
  margin-top: 5px;
  margin-right: 65px;
  margin-bottom: 15px;
  margin-left: 0;
}
.chat-list {
  overflow: scroll;
  overflow-x: hidden;
}
.chat-list::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space /
        background: transparent; / optional: just make scrollbar invisible /
        }
        / optional: show position indicator in red */
}
.btn-group {
  position: relative;
}
.send-group-btn {
  position: absolute;
  bottom: 0 !important;
  right: 0 !important;
  left: auto !important;
  height: fit-content;
}
.outside-click {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height:100vh;
  background-color: transparent;
}
.attach-box {
  width: 50px;
  height: 50px;
  border: 1px dashed gray;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.attach-box::before {
  content: '+';
  font-size: 1rem;
  font-weight: 500;
  color: gray;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.attach-control {
  display: inline-block;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.input-message {
  background-color: #f8f9fa;
}
.message-box .message-widget a .mail-contnet .mail-desc {
  font-size: 15px;
}

.message-box .message-widget a .mail-contnet .mail-desc,
.message-box .message-widget a .mail-contnet .time {
  white-space: pre-line;
}
</style>